import type { Holiday } from "@/config/holidays";

const PARTICLE_COUNT = 18;

/** Deterministic hash for stable pseudo-random values across re-renders. */
function hash(str: string): number {
  let h = 0;
  for (let i = 0; i < str.length; i++) {
    h = ((h << 5) - h + str.charCodeAt(i)) | 0;
  }
  return Math.abs(h);
}

function particleStyle(holiday: Holiday, index: number) {
  const seed = hash(holiday.id + index);
  const left = (seed % 1000) / 10; // 0-99.9%
  const duration = 12 + (seed % 18); // 12-29s
  const delay = -(seed % 20); // stagger start
  const drift = ((seed % 60) - 30); // -30px to +30px horizontal drift
  const opacity = 0.15 + ((seed % 26) / 100); // 0.15-0.40
  const size = 16 + (seed % 12); // 16-27px

  return {
    left: `${left}%`,
    fontSize: `${size}px`,
    opacity,
    animationDuration: `${duration}s`,
    animationDelay: `${delay}s`,
    "--drift": `${drift}px`,
  } as React.CSSProperties;
}

export function HolidayParticles({ holiday }: { holiday: Holiday }) {
  return (
    <div
      className="holiday-particles"
      aria-hidden="true"
      style={{
        position: "fixed",
        inset: 0,
        pointerEvents: "none",
        zIndex: 50,
        overflow: "hidden",
      }}
    >
      {Array.from({ length: PARTICLE_COUNT }, (_, i) => (
        <span
          key={i}
          className="holiday-particle"
          style={particleStyle(holiday, i)}
        >
          {holiday.emoji[i % holiday.emoji.length]}
        </span>
      ))}
    </div>
  );
}
